import { IPropertyForm } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";

const addInitialTags = (text: string): string => {
  if (/^<p>/.test(text)) {
    return text;
  } else {
    return `<p>${text}</p>`;
  }
};

const prepareSeoToServer = (body: IPropertyForm) => {
  const seo: any = {
    es: {
      title: body.seo_title_es_property,
      description: addInitialTags(body.seo_description_es_property),
      short_description: body.seo_short_description_es_property,
      keywords: body.seo_keywords_es_property.join(",")
    },
    en: {
      title: body.seo_title_en_property,
      description: addInitialTags(body.seo_description_en_property),
      short_description: body.seo_short_description_en_property,
      keywords: body.seo_keywords_en_property.join(",")
    }
  };
  return seo;
};

export default prepareSeoToServer;
